import { FileDTO } from "bbsf-controls"

export class UploadJsonVM
{
      ResourcesFile:FileDTO
      SelectedResourceSet :string
}
     